<template>
  <div
    class="infoButton"
    @mouseover="showHint"
    @mouseleave="hideHint"
  >
    <img
      src="https://sirvwebsite.sirv.com/assets/question.svg"
      :alt="hint"
    >
    <div class="hintWrapper hint">
      <div
        v-if="status"
        class="hintButton question"
      >
        {{ hint }}
      </div>
    </div>
  </div>
</template>

<script>
import { hintMixin } from "@/mixins/hint.mixin";

export default {
  name: 'ActionHint',
  mixins: [hintMixin],
  props: {
    hint: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.hintWrapper.hint {
  left: -200px;
  @media only screen and (min-width : 480px){
    left: auto;
  }
}
</style>
